import {UPDATEMENULIST} from '../constact'
const menuList = data => ({
    type: UPDATEMENULIST,
    data
})
export default menuList;